<template>
    <div class="main-container">

        <!-- Navbar section -->
        <NavbarTwo />

        <!-- slider section -->
        <HeroBannerFive />

        <!-- Medical info section -->
        <MedicalInfo/>

        <!-- why choose us section -->
        <Appointment />

        <!-- about app -->
        <CounterUpTwo/>

        <!-- Service style -->
        <Service />

        <!-- Testimonial section -->
        <TestimonialFour testimonialStyle="testimonial-five" />

        <!-- team section -->
        <TeamDoctor />

        <!-- download section -->
        <!-- <DownloadFour /> -->
        <!-- <ScreenshotThree /> -->
        <!-- policy section -->
        <!-- <Policy /> -->

        <!-- call to action -->
        <!-- <CallToAction /> -->

        <!-- department section -->
        <Department />

        <!-- Blog section -->
        <!-- <Blog /> -->

        <!-- google map section -->
        <GoogleMap />

        <!-- footer section -->
        <FooterTwo />

    </div>
</template>

<script>
    import NavbarTwo from '../components/NavbarTwo'
    import HeroBannerFive from '../components/HeroBannerFive'
    import MedicalInfo from '../components/MedicalInfo'
    import Appointment from '../components/Appointment'
    import CounterUpTwo from '../components/CounterUpTwo'
    import Service from '../components/Service'
    import TestimonialFour from '../components/TestimonialFour'
    import TeamDoctor from '../components/TeamDoctor'
    import Department from '../components/Department'
    //import Blog from '../components/Blog'
    import GoogleMap from '../components/GoogleMap'
    import FooterTwo from '../components/FooterTwo'
    // import ScreenshotThree from '../components/ScreenshotThree'

    export default {
        name: 'app',
        components: {
            NavbarTwo,
            HeroBannerFive,
            // ScreenshotThree,
            MedicalInfo,
            Appointment,
            CounterUpTwo,
            Service,
            TestimonialFour,
            TeamDoctor,
            Department,
            //Blog,
            GoogleMap,
            FooterTwo,
        },
        metaInfo:{
            title: 'Laborator Helios Med', 
        },
        head(){
            return {
                title: 'Helios Med Laborator',
                meta: [
                    {name: 'Laborator',content:'Laborator Analizash'},
                    {name: 'Analiza',content:'Hormonale, Mikrobiologjike, Hepatologjike, Biokimike'},
                    {name: 'Teknologjia',content:'Cobas e411, AIA-360 Automated Immunoassay Analyzer, DCA Voltage Analyzer, Biokimike'},
                ]
            }
        }
    }
</script>

